"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StateClassifierValue = void 0;
const shared_1 = require("../../../../backend/features/default-classifiers/shared");
const hooks_1 = require("../../../../ui/hooks");
const usePlatformSdkReactTranslation_1 = require("../../../../ui/hooks/usePlatformSdkReactTranslation");
const material_1 = require("@mui/material");
const react_1 = __importDefault(require("react"));
const StateClassifierValue = ({ state, filter, fontSize, variant }) => {
    const { t } = (0, usePlatformSdkReactTranslation_1.usePlatformSdkReactTranslation)();
    const storage = (0, hooks_1.useStorageClient)(shared_1.jurisdictionEntityName);
    const [response, setResponse] = react_1.default.useState();
    const [error, setError] = react_1.default.useState();
    react_1.default.useEffect(() => {
        if (state) {
            storage
                .list({ filter: [{ column: 'postalCode', op: '=', value: state, ...(filter ? filter : []) }], limit: 1 })
                .then(setResponse)
                .catch(setError);
        }
        else {
            setResponse(undefined);
            setError(undefined);
        }
    }, [storage, state, filter]);
    if (response && response.rows.length > 0) {
        return (react_1.default.createElement(material_1.Typography, { component: 'span', fontSize: fontSize, variant: variant },
            response.rows[0].columns.name,
            response.rows[0].columns.status !== 'active' &&
                ' (' + t(`classifiers.statusEnum.${response.rows[0].columns.status}`) + ')'));
    }
    else if (error) {
        return (react_1.default.createElement(material_1.Typography, { component: 'span', color: 'error', fontSize: fontSize }, "Error"));
    }
    else {
        return react_1.default.createElement(material_1.Typography, { component: 'span', fontSize: fontSize });
    }
};
exports.StateClassifierValue = StateClassifierValue;
